import { ref, readonly } from 'vue';

/**
 * @typedef {Object} AlertProps
 * @property {import('vue').ComputedRef<string>} alertName
 * @property {import('vue').ComputedRef<string>} alertAction
 * @property {function:void} onClose
 */

/**
 * creates the props for alerts
 *
 * @return {{
 *   alertProps: Object<AlertProps>,
 *   onErrorAlert: function:void,
 * }}
 */
export function useAlertsProps() {
  const alertName = ref('');
  const alertAction = ref('');

  const onErrorAlert = (value) => {
    alertName.value = value;
    alertAction.value = 'error';
  };

  const alertProps = {
    name: readonly(alertName),
    action: readonly(alertAction),
    onClose: () => {
      // allows time for the fade-out transition to happen
      alertName.value = '';
      alertAction.value = '';
    },
  };

  return {
    onErrorAlert,
    alertProps,
  };
}

export default useAlertsProps;
